/* import __COLOCATED_TEMPLATE__ from './shipping-address-card.hbs'; */
import Component from '@glimmer/component';
import { addressEntry } from '@banking/ui/utils/address';
export default class ShippingAddressCard extends Component {
  get formattedAddress() {
    return addressEntry(this.args.address, {
      hideCountryCode: true
    });
  }
}